import React from 'react';

const SelfLifeDetails =  React.memo(({ selfLifedata, setSelfLifeData }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setSelfLifeData({ ...selfLifedata, [name]: value });
  };

  return (
    <div className="grid grid-cols-2 gap-6 mx-10">
      <div className="flex flex-col">
        <label htmlFor="productLife" className="font-semibold text-[#667085]">
          Product Life
        </label>
        <div className="w-full flex mt-2 space-x-2">
          <select
            id="expiryLife"
            name="p_lifespan"
            value={selfLifedata.p_lifespan}
            onChange={handleChange}
            required
            className="p-2 border border-gray-300 rounded-md flex-1 outline-sky-300"
          >
            <option value="">Select</option>
            <option name="p_lifespan" value="day">Day</option>
            <option name="p_lifespan" value="month">Month</option>
            <option name="p_lifespan" value="year">Year</option>
          </select>

          <input
            id="productLife"
            name="p_life" 
            value={selfLifedata.p_life}
            onChange={handleChange}
            type="text"
            placeholder='Enter the Period....'
            className="p-2 border border-gray-300 rounded-md flex-1 outline-sky-300"
          />
        </div>
      </div>
    </div>
  );
});

export default SelfLifeDetails;
